import { render, staticRenderFns } from "./ComplementaryExams.vue?vue&type=template&id=da1f932c&scoped=true"
import script from "./ComplementaryExams.vue?vue&type=script&lang=js"
export * from "./ComplementaryExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1f932c",
  null
  
)

export default component.exports